import { ContentItem } from '@apptus/esales-api';
import { IQuickSearchResultPage } from '../../../../types';
import handleFromUrl from '../../../../../../util/handleFromUrl';
import { generateContentTicket } from '../handleTickets';

const mapPage = (pageInResp: ContentItem, searchTerm?: string): IQuickSearchResultPage => {
  // Store the ticket in localStorage if we have a search term (autocomplete context)
  if (searchTerm && pageInResp.ticket) {
    generateContentTicket(pageInResp, searchTerm);
  }

  return {
    id: pageInResp.key.toString(),
    handle: handleFromUrl(pageInResp.link),
    title: pageInResp.title,
    url: pageInResp.link,
    ticket: pageInResp.ticket,
    description: pageInResp.description,
    type: 'Info'
  };
};

export default mapPage;
